import { Button, Result } from 'antd'
import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom'

function resolveError(error: unknown): { title: string; subtitle: string } {
    if (isRouteErrorResponse(error)) {
        if (error.status === 404) {
            return {
                title: '页面不存在',
                subtitle: '你访问的地址不存在，或已被移除。',
            }
        }
        return {
            title: `请求异常（${error.status}）`,
            subtitle: String(error.statusText || error.data || '页面加载失败，请稍后重试。'),
        }
    }

    if (error instanceof Error && error.message) {
        return {
            title: '页面出错了',
            subtitle: error.message,
        }
    }

    return {
        title: '页面出错了',
        subtitle: '发生了未预期的错误，请刷新后重试。',
    }
}

export default function RouteErrorPage() {
    const error = useRouteError()
    const navigate = useNavigate()
    const { title, subtitle } = resolveError(error)

    return (
        <div
            style={{
                minHeight: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 24,
                background: 'var(--bg-root)',
            }}
        >
            <Result
                status="error"
                title={<span style={{ color: '#fff' }}>{title}</span>}
                subTitle={<span style={{ color: 'var(--text-3)' }}>{subtitle}</span>}
                extra={[
                    <Button key="retry" type="primary" onClick={() => window.location.reload()}>
                        刷新页面
                    </Button>,
                    <Button key="home" onClick={() => navigate('/managers', { replace: true })}>
                        返回首页
                    </Button>,
                ]}
            />
        </div>
    )
}
